// A city's looks: other scenes of the same city (Rome: the Trevi Fountain, or the lane to the Colosseum), listed in the
// registry (`looks`, site/js/scenes/registry.js). The city's title shows a chip per look, ↑ and ↓ go through them, and
// the pick is kept per city for the next visit (site/js/app.js). Everything else about the city stays one: its page,
// its people, its passport stamp. Pure (no DOM, no storage), so node can test it: node --test tests/
import { looksOf } from '../scenes/registry.js';

/** The kept picks, { city id: look id }, cleaned: only cities that have that look, and never a city's first look. */
export function looksPicked(stored, cities) {
  const picks = {};
  if (!stored || typeof stored !== 'object' || Array.isArray(stored)) return picks;
  for (const city of cities) {
    const pick = stored[city.id];
    if (looksOf(city).slice(1).some(look => look.id === pick)) picks[city.id] = pick;
  }
  return picks;
}

/** The look a city shows: the visitor's pick, or its first. */
export const lookOf = (city, picks) => looksOf(city).find(look => look.id === picks?.[city.id]) ?? looksOf(city)[0];

/** `picks` with `look` picked for the city (a copy): the first look is the city as it comes, so it isn't kept. */
export function withLook(picks, city, look) {
  const { [city.id]: _, ...rest } = picks;
  return looksOf(city).slice(1).some(l => l.id === look) ? { ...rest, [city.id]: look } : rest;
}

/** The look `step` after (or before) `look` among the city's, round and round; the same one for a city with one look. */
export function stepLook(city, look, step) {
  const looks = looksOf(city), i = Math.max(0, looks.findIndex(l => l.id === look));
  return looks[(((i + step) % looks.length) + looks.length) % looks.length];
}
